import React, { FC } from 'react';
import { TypeSmallTextBlockFields } from '@/core/generated-types';

const SmallTextBlock: FC<TypeSmallTextBlockFields> = ({ title, Subtitle }) => {
  return (
    <div className="my-12 px-8 text-center">
      <div className="text-[20px] font-bold md:text-2xl">{title}</div>
      <div className="mx-auto mt-4 text-base md:max-w-[1100px] md:max-w-[67%] md:text-lg">
        {Subtitle}
      </div>
    </div>
  );
};

export default React.memo(SmallTextBlock);
